// material-ui

// ==============================|| OVERRIDES - LIST ITEM ICON ||============================== //

export default function ListSubheader() {
  return {
    MuiListSubheader: {
      styleOverrides: {
        root: {
          backgroundColor: 'transparent',
        }
      }
    }
  };
}
